"use client";

import * as events from "@/events";
import {
  emitDocumentTracking,
  emitModalTracking,
} from "@/shared/tracking/analytics";
import { getKeyFactsStatementTitleKey } from "@/lib/checkout-documents";
import type { AppContext, CheckoutSession } from "@/types";

interface KeyFactsAcknowledgementLineProps {
  ctx: AppContext;
  session: CheckoutSession;
  onOpenKfsModal: () => void;
}

export function KeyFactsAcknowledgementLine({
  ctx,
  session,
  onOpenKfsModal,
}: KeyFactsAcknowledgementLineProps) {
  const { t, rtl, sendEvent } = ctx;
  const kfsTitleKey = getKeyFactsStatementTitleKey(session.order.countryCode);

  const handleOpenModal = () => {
    sendEvent(events.VIEW_FINANCE_DOCUMENTS_CLICKED);
    emitDocumentTracking("finance_documents_viewed", session);
    emitModalTracking("documents_modal_opened", session, {
      modal_name: "key_facts_statement",
    });
    onOpenKfsModal();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleOpenModal();
    }
  };

  return (
    <div
      className="mt-4 pl-[10px]"
      dir={rtl ? "rtl" : "ltr"}
      data-testid="kfs-acknowledgement-line"
    >
      <div className="text-[12px] font-medium leading-4 text-[#585B7A] tracking-[-0.18px]">
        <span>{t("payment_confirmation.kfs_acknowledgement_prefix")}</span>{" "}
        <div
          role="button"
          tabIndex={0}
          className="inline font-bold text-[#9600F1] cursor-pointer hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#9600F1]"
          onClick={handleOpenModal}
          onKeyDown={handleKeyDown}
          data-testid="kfs-acknowledgement-link"
        >
          {t(kfsTitleKey)}
        </div>
      </div>
    </div>
  );
}
